<template>
  <v-container fluid class="tp-page">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Redes</h1>
          <p class="tp-page-sub">{{ tabela.conteudo.length }} {{ tabela.conteudo.length === 1 ? 'rede' : 'redes' }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon v-if="item.ativo == true" color="success">circle</v-icon>
            <v-icon v-else color="error">circle</v-icon>
          </template>
          <template v-slot:[`item.cor`]="{ item }">
            <v-chip :color="item.cor" small label dark>{{ item.cor }}</v-chip>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhuma rede encontrada</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- CARD INSERE/EDITA REDE -->
    <v-card v-else class="tp-card tp-form" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <p style="font-size:13px; color:#00695C; margin:0"> *Preencha todos os campos</p>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-text-field v-model="editedItem.nome" hide-details outlined label="Nome" color="#00695C"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <swatches v-model="editedItem.cor" popover-x="left" swatches="text-advanced">
              <v-text-field slot="trigger" hide-details v-model="editedItem.cor" outlined label="Cor" color="#00695C"></v-text-field>
            </swatches>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model="editedItem.dataFundacao" type="tel" v-mask="'##/##/####'" outlined label="Data de Fundação" color="#00695C"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model="editedItem.lider" outlined label="Nome do Líder" color="#00695C" hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model="editedItem.telefone" outlined label="WhatsApp com DDD" color="#00695C" type="tel" v-mask="'(##) #####-####'"></v-text-field>
          </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-switch v-model="editedItem.visivel" label="Visível" color="#00695C" inset></v-switch>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
        <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import Swatches from 'vue-swatches'
  import 'vue-swatches/dist/vue-swatches.css'
  export default {
    components: { Snackbar, Loading, Swatches },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      adicionarDivulgador: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Cor', value: 'cor' },
          { text: 'Data de Fundação', value: 'dataFundacao' },
          { text: 'Líder', value: 'lider' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: []
      },
      editedIndex: -1,
      editedItem: {
        nome: '',
        cor: '',
        dataFundacao: '',
        lider: '',
        telefone: null,
        visivel: true,
      },
      defaultItem: {
        nome: '',
        cor: '',
        dataFundacao: '',
        lider: '',
        telefone: null,
        visivel: true,
      },
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVA REDE ' : 'EDITAR REDE'
      }
    }),

    mounted() {
      this.carregaRedes()
    },

    watch: {
      
    },

    methods: {
      async carregaRedes() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Redes?filter={"where":{"igrejaId":"'+this.user.igrejaId+'"}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken')).then(response => {          if (response.data) {
            this.tabela.conteudo = response.data 
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      criarNovo() {
        this.adicionarDivulgador = true
        this.addUser = true
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarDivulgador = true
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a rede: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Redes/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaRedes()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        var vm = this;
        if (this.editedIndex != -1) {
          if (this.editedItem.nome || this.editedItem.cor || this.editedItem.dataFundacao || this.editedItem.lider || this.editedItem.telefone) {
            await axios.patch(`${baseApiUrl}Redes/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)            .then(response => {
              if (response.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaRedes()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        } else {
          if (this.editedItem.nome || this.editedItem.cor || this.editedItem.dataFundacao || this.editedItem.lider || this.editedItem.telefone) {
            this.editedItem.igrejaId = this.user.igrejaId
            await axios.post(`${baseApiUrl}Redes/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)            .then(response => {
              if (response.data != null) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Rede cadastrada com sucesso!", "INFORMAÇÃO")
                this.carregaRedes()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar rede, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>